import { render, staticRenderFns } from "./tagName.vue?vue&type=template&id=6d11d72d&scoped=true"
import script from "./tagName.vue?vue&type=script&lang=js"
export * from "./tagName.vue?vue&type=script&lang=js"
import style0 from "./tagName.vue?vue&type=style&index=0&id=6d11d72d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11d72d",
  null
  
)

export default component.exports